import { CollectionFunction } from 'data/collectionFunction/collectionFunction.types';
import { RootState } from '../root.reducers';
import {
  XcipioNodesTopology, NetworkTopologyMapData, NetworkTopologyMapConfig, NetworkTopologyFilter
} from './network-topology.types';

export const getNetworkTopologyMapData = (state: RootState): NetworkTopologyMapData => state.networkTopology.mapData;
export const getOriginalNetworkTopologyMapData = (state: RootState): NetworkTopologyMapData => state.networkTopology.originalMapData;
export const getNetworkTopologyConfig = (state: RootState): NetworkTopologyMapConfig => state.networkTopology.networkTopologyMapConfg;
export const getNetworkTopologyCustomFilters = (state: RootState): NetworkTopologyFilter[] => state.networkTopology.customFilters;
export const getNetworkTopologyLocations = (state: RootState): string[] => {
  const afLocations = getPOIParameters(state.networkTopology.originalMapData.accessFunctions, 'city');
  const cfLocations = getPOIParameters(state.networkTopology.originalMapData.collectionFunctions, 'city');
  return [...afLocations, ...cfLocations];
};

export const getCfTypes = (state: RootState): string[] => {
  return getPOIParameters(state.networkTopology.originalMapData.collectionFunctions, 'type');
};

const getPOIParameters = (
  poiDataList: any[],
  parameter: string,
): string[] => {
  const parameterDataMap = new Set<string>();
  poiDataList.forEach((item) => {
    const parameterData = item?.data?.[parameter];
    if (parameterData) {
      parameterDataMap.add(parameterData);
    }
  });

  return Array.from(parameterDataMap.values()).sort();
};

export const getSelectedNetworkTopologyFilter = (state: RootState): NetworkTopologyFilter => state.networkTopology.selectedCustomFilter;

export const getCollectionFunctionsNetworkTopology = (state: RootState): CollectionFunction[] => state.networkTopology.collectionFunctions;

export const getNetworkTopologyLoading = (state: RootState): boolean => state.networkTopology.ui.isLoading;
export const getIsNetworkTopologyLoaded = (state: RootState): boolean => state.networkTopology.ui.isNetworkTopologyLoaded;
export const getZoomInLocarion = (state: RootState): {
  latitude: number;
  longitude: number;
  zoom: number;
} | undefined => state.networkTopology.zoomInLocarion;
